import * as React from 'react'
import { Button } from 'react-bootstrap'

import * as actions from '../../redux/actions'
import config from '../../constants/config'
import { copyObject } from '../../utils'

import GeneralAccount, { GeneralAccountObj, GeneralAccountT } from './GeneralAccount'
import { AxiosInstance } from '../../utils/RequestMethods'


const accounts = [
  "Assets",
  "Liabilities",
  "Stockholders' Equity",
  "Operating Revenues",
  "Cost of Goods Sold",
  "Expenses"
]

interface GeneralAccountsProps { }

const GeneralAccounts: React.FunctionComponent<GeneralAccountsProps> = ({ }) => {
  const [generalAccounts, setGeneralAccounts] = React.useState([])

  const isUniqueId = (id: number): boolean => {
    let matches = generalAccounts.filter((acc: GeneralAccountT): boolean => {
      if (acc.id == id) return true
      return false
    })
    if (matches.length > 0) return false
    return true
  }

  const generateUniqueId = (): number => {
    let tempId = Math.floor(Math.random() * 1100000)
    let matches = generalAccounts.filter((acc: GeneralAccountT): boolean => {
      if (acc.id == tempId) return true
      return false
    })
    if (matches.length > 0) return generateUniqueId()
    return tempId
  }

  const initializeGeneralAccounts = async () => {
    fetchGeneralAccounts().then(
      (res) => {
        if (res && res.data) {
          console.log('CHART OF ACCOUNTS: ', res.data)

          res.data.map((item: GeneralAccountT) => {
            let generalAccountsCopy = copyObject(generalAccounts)
            generalAccountsCopy.push(item)
            setGeneralAccounts(generalAccountsCopy)
          })
        }

      }
    )
  }

  React.useEffect(() => {
    initializeGeneralAccounts()
  }, [])

  const fetchGeneralAccounts = async () => {
    let options = {
      data: {}
    }
    return await AxiosInstance.get(`${config.url.wpJson}/wp/v2/accounting/general_accounts`)
  }

  const deleteGeneralAccount = (id: number): void => {
    let gaTemp = copyObject(generalAccounts)
    gaTemp.splice(gaTemp.findIndex(acc => acc.id === id), 1);
    setGeneralAccounts(gaTemp)
  }

  const displayAccounts = (accountType: string) => {
    return generalAccounts.filter((acc: GeneralAccountT) => {
      if (acc.account_type == accountType) return true
      else return false
    }).map((ga: GeneralAccountT, index: number) => {
      return <GeneralAccount
        key={index}
        account={ga}
        deleteGeneralAccount={deleteGeneralAccount}
        updateAccount={updateAccount} />
    })
  }

  const updateAccount = (id: number, key: string, value: string): void => {
    let gaTemp = copyObject(generalAccounts)
    gaTemp[gaTemp.findIndex(acc => acc.id === id)][key] = value
    setGeneralAccounts(gaTemp)
  }

  const dAccounts = () => {
    return accounts.map((account: string) => {
      return (
        <div>
          <h4>{account}</h4>
          {displayAccounts(account)}
          <Button
            onClick={() => {
              let gaCopy = copyObject(generalAccounts)
              let gaItem = copyObject(GeneralAccountObj)
              gaItem.id = generateUniqueId()
              gaItem.account_type = account
              gaCopy.push(gaItem)
              setGeneralAccounts(gaCopy)
            }}
            variant="outline-secondary">Add {account} Account</Button>
        </div>
      )
    })
  }

  return (
    <div>
      <h2>General Accounts</h2>
      {dAccounts()}
    </div>
  )
}

export default GeneralAccounts
